import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'react-lottie';
import styled from 'styled-components';
import doneAnimation from '../Animations/done.json'; // Make sure to import your Lottie animation file

const PaymentDone = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Prevent going back
    const preventGoingBack = (e) => {
      e.preventDefault();
      window.history.pushState(null, '', window.location.href);
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', preventGoingBack);

    return () => {
      window.removeEventListener('popstate', preventGoingBack);
    };
  }, []);

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: doneAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <Container>
      <LottieWrapper>
        <Lottie
          options={defaultOptions}
          height={300}
          width={300}
          eventListeners={[
            {
              eventName: 'complete',
              callback: () => navigate('/') // Navigate to home page after animation completes
            }
          ]}
        />
      </LottieWrapper>
      <Message>Thank you for your purchase!</Message>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
`;

const LottieWrapper = styled.div`
  width: 300px;
  height: 300px;
`;

const Message = styled.p`
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-top: 20px;
`;

export default PaymentDone;